var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.on,staticClass:"agToggle",class:{'agToggle_disabled': _vm.disabled},on:{"click":_vm.agToggle_click}},[_c('div',{staticClass:"agToggle-container",class:{'on': _vm.on}},[_c('div',{staticClass:"agToggle-button"})]),_vm._v(" "),_c('div',{staticClass:"agToggle-label",class:_vm.labelClass},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e08d1412","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Toggle.vue
// module id = null
// module chunks = 